module.exports = __webpack_public_path__ + "static/media/balancer.86ea0198.svg";